"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MainHeader = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _LogoLink = require("../../../UIElements/Logos/LogoLink");
var _UserMenu = require("../../Menus/UserMenu/UserMenu");
var _Icon = require("../../../UIElements/Icons/PetSure/Icon");
var _propTypes = require("../../../../propTypes");
require("./mainHeader.scss");
const _excluded = ["redirectUrl", "imageUrl", "imageTitle", "imageTitleDescription", "imageTitleDescriptionMobile"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const MainHeader = _ref => {
  let {
    children,
    logos,
    logoStyle = 'default',
    pageTitleText,
    customContent,
    customCssClass,
    headerShouldPin,
    headerNav,
    customUserNav,
    contactDetails,
    showLogo = true,
    user = null,
    isDialogPage = false,
    onDialogClose,
    onLogout = () => {},
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const mainHeader = (0, _react.useRef)(null);
  const dialogCloseButton = (0, _react.useRef)(null);
  const [isPinned, setIsPinned] = (0, _react.useState)(false);
  const handleDialogClose = () => {
    if (onDialogClose) {
      onDialogClose();
    }
  };
  (0, _react.useEffect)(() => {
    if (headerShouldPin) {
      window.addEventListener('scroll', event => {
        const scrollAmount = event.currentTarget.scrollY;
        if (scrollAmount) {
          setIsPinned(true);
        } else {
          setIsPinned(false);
        }
      });
    }
  });
  (0, _hooks.useTracking)({
    elementRef: dialogCloseButton,
    trackingProps: {
      label: 'Main header dialog close button'
    },
    customTrackingData,
    customTrackingEvents
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: mainHeader,
    className: "mainHeader \n        ".concat(headerNav || customUserNav ? 'withNavigation' : '', " \n        ").concat(customUserNav ? 'withCustomUserNav' : '', " \n        ").concat(showLogo ? 'withLogo' : '', " \n        ").concat(customCssClass || '', " \n        ").concat(isPinned ? 'isPinned' : '')
  }, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement("section", null, showLogo && logos && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, logos.map(_ref2 => {
    let {
        redirectUrl,
        imageUrl,
        imageTitle,
        imageTitleDescription,
        imageTitleDescriptionMobile
      } = _ref2,
      rest = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/_react.default.createElement(_LogoLink.LogoLink, _extends({}, rest, {
      key: redirectUrl,
      href: redirectUrl,
      logoImageUrl: imageUrl,
      isCatchLogo: logoStyle === 'catch',
      isGapOnlyLogo: logoStyle === 'gapOnly',
      isCustomLogo: logoStyle === 'custom',
      imageTitle: imageTitle,
      imageTitleDescription: imageTitleDescription,
      imageTitleDescriptionMobile: imageTitleDescriptionMobile
    }));
  }))), pageTitleText && /*#__PURE__*/_react.default.createElement("h1", null, pageTitleText), headerNav, customContent, user && /*#__PURE__*/_react.default.createElement(_UserMenu.UserMenu, {
    user: user,
    condensed: true,
    onLogout: onLogout
  }), customUserNav, isDialogPage && /*#__PURE__*/_react.default.createElement("section", {
    className: "headerDialogControl"
  }, /*#__PURE__*/_react.default.createElement("button", {
    ref: dialogCloseButton,
    onClick: () => handleDialogClose(),
    type: "button",
    className: "button icon_only"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Close dialog"), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "close"
  }))), contactDetails && /*#__PURE__*/_react.default.createElement("section", {
    className: "contactDetails"
  }, contactDetails)), children && /*#__PURE__*/_react.default.createElement("section", {
    className: "customHeaderBar"
  }, children));
};
exports.MainHeader = MainHeader;
MainHeader.propTypes = _propTypes.MainHeaderPropTypes;
var _default = exports.default = MainHeader;